import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { CheckPersonRulesMatrixModel, PersonModel } from '@bayclubs/court-booking-employee-api';
import { CourtBookingSaveFacade } from './../../+store/court-booking-save.facade';

export const CUSTOM_PLAYER_SEARCH_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CourtBookingPlayerSearchComponent),
    multi: true
};

@Component({
    selector: 'app-court-booking-player-search',
    templateUrl: './court-booking-player-search.component.html',
    styleUrls: ['./court-booking-player-search.component.scss'],
    providers: [CUSTOM_PLAYER_SEARCH_VALUE_ACCESSOR],
    standalone: false
})
export class CourtBookingPlayerSearchComponent implements OnInit, OnDestroy, ControlValueAccessor {
    @Input() playerRules: CheckPersonRulesMatrixModel;

    players$ = this.courtBookingSaveFacade.players$;

    categoryName$ = this.courtBookingSaveFacade.selectedCategoryName$;

    form: UntypedFormGroup;

    subscription: Subscription = new Subscription();

    selectedPerson: PersonModel;

    constructor(private formBuilder: UntypedFormBuilder, private courtBookingSaveFacade: CourtBookingSaveFacade) { }

    onChange = (selected: PersonModel) => { };
    onTouched = () => { };
    writeValue(person: PersonModel): void {
        this.selectedPerson = person;
    }
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void { }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            search: [null]
        });
        this.initFormSubscription();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    initFormSubscription() {
        this.subscription.add(
            this.form.controls.search.valueChanges.pipe(debounceTime(1000)).subscribe(value => {
                this.courtBookingSaveFacade.searchPlayers(value);
            })
        );
    }

    selectPerson(person: PersonModel) {
        this.selectedPerson = person;
        this.form.controls.search.setValue(null);
        this.onChange(person);
        this.courtBookingSaveFacade.clearPlayers();
    }

    clearSelectedPerson() {
        this.selectedPerson = null;
        this.onChange(null);
    }
}

export interface CourtBookingPlayerSearchFormModel {
    search: string;
}
